import script from "./TabPanel.vue?vue&type=script&lang=ts"
export * from "./TabPanel.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__